import { useState } from "react";
import { apiBlob, ErrorApi } from "../api.ts";
import { guardarPdf } from "../guardarArchivo.ts";

/** Guarda el documento como PDF en el computador (el firmado digitalmente tal cual, o el mismo documento sin firma digital). En Chrome y Edge abre «Guardar como» en el Escritorio. */
export function GuardarPdf({ tipo, id, nombre, etiqueta = "Guardar PDF" }: { tipo: "receta" | "certificado" | "consentimiento" | "indicacion" | "abono" | "sonrisa" | "simulacion" | "presupuesto"; id: string; nombre: string; etiqueta?: string }) {
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState("");
  async function guardar() {
    setOcupado(true); setError("");
    try {
      await guardarPdf(`${nombre.replace(/[^\p{L}\p{N}._-]+/gu, "_")}.pdf`, async () => {
        const url = await apiBlob(`/api/documentos/${tipo}/${id}/archivo`);
        try { return await (await fetch(url)).blob(); } finally { URL.revokeObjectURL(url); }
      });
    } catch (e) { setError(e instanceof ErrorApi || e instanceof Error ? e.message : "No se pudo guardar el PDF."); }
    finally { setOcupado(false); }
  }
  return (
    <>
      <button className="btn chico" disabled={ocupado} onClick={guardar} title="Descarga el documento como archivo PDF">{ocupado ? "Guardando…" : etiqueta}</button>
      {error && <span className="aviso error" role="alert" style={{ padding: "2px 8px", fontSize: 12 }}>{error}</span>}
    </>
  );
}
